module.exports = __webpack_public_path__ + "img/s00133.03388573.jpg";